














































































































































































































































































































































































import {Component, Watch, Vue, Prop} from 'vue-property-decorator'
import {namespace} from 'vuex-class'
import axios from 'axios'
import IArrow from '@/components/icons/IArrow.vue'
import IPencil from '@/components/icons/IPencil.vue'
import EditItem from '@/components/UI/EditItem.vue';
import BtnDefault from '@/components/UI/BtnDefault.vue';

const badges = namespace('badges')
const resources = namespace('resources')

@Component({
  components: {
    IArrow,
    IPencil,
    EditItem,
    BtnDefault,
  }
})

export default class SelectedBadge extends Vue {
  @badges.Getter('badge') protected badge: any
  @badges.Getter('loadingBadge') protected loadingBadge: any
  @badges.Action('patchCompanyMember') protected patchCompanyMember: any

  @resources.Getter('getCountries') protected getCountries: any
  @resources.Action('getCountryFromServer') protected getCountryFromServer: any

  panel:any = [0, 1, 2]
  type:string = ''
  search:string = ''
  country:any = ''
  isError:any = {
    contact_type: false,
    contact_value: false,
    location_country: false,
    promo_title: false,
    promo_value: false
  }
  newContact:any = {
    type: '',
    value: ''
  }
  newLocation:any = {
    _country: '',
    region: '',
    city: '',
    address: '',
    postcode: ''
  }
  newPromo:any = {
    title: '',
    value: ''
  }
  currentLocation:any = {}

  get contacts() {
    return [
      {
        id: 'phone',
        title: this.$t('newProfile.contacts_modal.phone')
      },
      {
        id: 'email',
        title: this.$t('newProfile.contacts_modal.email')
      },
      {
        id: 'site',
        title: this.$t('newProfile.contacts_modal.site')
      },
      {
        id: 'location',
        title: this.$t('newProfile.locations.title')
      },
    ]
  }

  mounted() {
    this.getCountryFromServer()
  }

  saveChange() {
    this.patchCompanyMember({
      params: {
        badgeId: this.badge._id
      },
      body: this.badge
    })
  }

  getContactTitle(contact:any) {
    let title:any
    if(contact.type == 'phone') {
      title = this.$t('newProfile.contacts_modal.phone')
    } else if (contact.type == 'email') {
      title = this.$t('newProfile.contacts_modal.email')
    } else if (contact.type == 'site') {
      title = this.$t('newProfile.contacts_modal.site')
    }
    return title
  }

  getLocation(location:any) {
    let address = ''
    if(location.postcode) address += location.postcode + ', '
    if(location._country && this.getCountries.filter((country:any) => country.code == location._country).length) address += this.getCountries.filter((country:any) => country.code == location._country)[0].title + ', '
    if(location.region) address +=  location.region + ', '
    if(location.city) address +=  location.city + ', '
    if(location.address) address += location.address + ', '
    return address.slice(0, -2)
  }

  deleteItem(field:string, index:string) {
    this.badge[field].splice(index, 1)
    this.saveChange()
  }

  addContact() {
    this.isError.contact_type = this.type == ''
    this.isError.contact_value = this.newContact.value == ''
    if(!this.isError.contact_type && !this.isError.contact_value) {
      this.newContact.type = this.type
      this.badge.contacts.push(this.newContact)
      this.newContact = {
        type: '',
        value: ''
      }
      this.type = ''
      this.saveChange()
    }
  }

  addLocation() {
    this.isError.location_country = this.newLocation._country == ''
    if(!this.isError.location_country) {
      this.badge.locations.push(this.newLocation)
      this.newLocation = {
        _country: '',
        region: '',
        city: '',
        address: '',
        postcode: ''
      }
      this.type = ''
      this.saveChange()
    }
  }

  addPromo() {
    this.isError.promo_title = this.newPromo.title == ''
    this.isError.promo_value = this.newPromo.value == ''
    if(!this.isError.promo_title && !this.isError.promo_value) {
      if(!this.badge.promo) this.badge.promo = []
      this.badge.promo.push(this.newPromo)
      this.newPromo = {
        title: '',
        value: ''
      }
      this.saveChange()
    }
  }

  openModalLocation(location:any) {
    this.currentLocation = {...location}
  }

  saveLocation(index:number) {
    this.badge.locations[index] = this.currentLocation
    this.saveChange()
  }
}
